import React from 'react';

function TimeAgo({ date }) {
  const getTimeAgo = (date) => {
    const seconds = Math.floor((new Date() - date) / 1000);

    let interval = seconds / 31536000; // years
    if (interval > 1) {
      return Math.floor(interval) + ' years ago';
    }

    interval = seconds / 2592000; // months
    if (interval > 1) {
      return Math.floor(interval) + ' months ago';
    }

    interval = seconds / 86400; // days
    if (interval > 1) {
      return Math.floor(interval) + ' days ago';
    }

    interval = seconds / 3600; // hours
    if (interval > 1) {
      return Math.floor(interval) + ' hours ago';
    }

    interval = seconds / 60; // minutes
    if (interval > 1) {
      return Math.floor(interval) + ' minutes ago';
    }

    return Math.floor(seconds) + ' seconds ago';
  };

  return (
    <span title={date.toLocaleString()}>
      {getTimeAgo(date)}
    </span>
  );
}

export default TimeAgo; 